import { render, staticRenderFns } from "./ProjectAccountingInvoiceEdit.vue?vue&type=template&id=2f2661e0"
import script from "./ProjectAccountingInvoiceEdit.vue?vue&type=script&lang=js"
export * from "./ProjectAccountingInvoiceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports